import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './sidebar-activities.module.css'
import ActivityStream from '../activities/activity-stream.js'
import { graphHooks } from '@tunasong/graph-lib/react'

export const SidebarActivities: FC<SidebarComponent> = ({ entity }) => {
  const activities = graphHooks.useActivities(entity.id)

  return (
    <div className={styles.container}>
      <ActivityStream activities={activities} />
    </div>
  )
}
